module.exports = __webpack_public_path__ + "static/img/z_pay_case.2cef2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/z_pay_case.png
// module id = rVS7
// module chunks = 8